module.exports = __webpack_public_path__ + "gq.svg?ef15bef6fb9911085e245d4da96dfd7c";